/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button, FormControl, MenuItem, Select } from "@mui/material";
import { Clear as ClearIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFilteredComponentCategories, getSortedComponentCategoryNames } from "cms/components/components/component-utils";

const ComponentFilterBar = (props) => {

    const { componentTypes, selectedFilter, setSelectedFilter, showFilterBar } = props;

    const componentCategories = useSelector((state) => state.component.categories);
    const [categoryFilters, setCategoryFilters] = useState([]);

    useEffect(() => {
        const categories = [...componentCategories];
        const filteredCategoryNames = getFilteredComponentCategories(categories, componentTypes);
        const sortedCategoryNames = getSortedComponentCategoryNames(filteredCategoryNames);
        setCategoryFilters(sortedCategoryNames);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [componentCategories]);

    const handleSelectFilter = (event) => {
        setSelectedFilter(event.target.value);
    };

    const clearFilterBar = () => {
        setSelectedFilter("");
        showFilterBar(false);
    };

    const showPlaceholderText = (selected) => {
        if (!selected) {
            return <span className='filter-placeholder'>Select a filter</span>;
        }
        return selected;
    };

    return (
        <div className='component-filter-bar'>
            <FormControl fullWidth size='small'>
                <Select
                    displayEmpty
                    id='component-filter-select'
                    onChange={handleSelectFilter}
                    placeholder='Select a filter'
                    renderValue={showPlaceholderText}
                    value={selectedFilter}
                >
                    {categoryFilters.map((filter) => (
                        <MenuItem key={filter} value={filter}>
                            {filter}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Button className='component-action-button' onClick={clearFilterBar}>
                <ClearIcon />
            </Button>
        </div>
    );
};

export { ComponentFilterBar };
